import { gql } from "apollo-boost";

export const GET_SUBBRANDS = gql`
query SubBrands($where: SubBrandWhereInput) {
  subBrands(where: $where) {
    total
    data {
      name
      id
      isDeleted
      brand {
        id
        name
      }
    }
  }
}
`